module.exports = __webpack_public_path__ + "img/HOME-8.4bdc63fc.png";